var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('a',{attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }